import { TIPO_TEMPLATE_EMAIL } from './../../config/tipo-template-email.config';
import { TemplateEmailDTO } from '../../models/comunicacao/templateEmailDTO';
import { HttpClient } from '@angular/common/http';
import { API_CONFIG } from './../../config/api.config';
import { Observable } from 'rxjs/internal/Observable';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TemplateEmailService {

  constructor(private http: HttpClient){ 
  }

  insert(templateEmailDTO: TemplateEmailDTO) : Observable<any> {
    

    return this.http.post<any>( API_CONFIG.apiURL+'/templatesemail'
                              , templateEmailDTO
                              , { observe: 'response' }); //.pipe(timeout(100000))

  }

  saveAll(templates: TemplateEmailDTO[]) : Observable<any> {
    
    return this.http.post<any>( API_CONFIG.apiURL+'/templatesemail/saveAll'
                              ,  JSON.stringify(templates)
                              , { observe: 'response' }); //.pipe(timeout(100000))

  }

  update(templateEmailDTO: TemplateEmailDTO) : Observable<any> {
    
    return this.http.put<any>( API_CONFIG.apiURL+'/templatesemail/' + templateEmailDTO.id
                             , templateEmailDTO
                             , { observe: 'response' });

  }


  findAll() : Observable<TemplateEmailDTO[]> {

    return this.http.get<TemplateEmailDTO[]>( API_CONFIG.apiURL+'/templatesemail');

  }

  
  find(id: number) : Observable<TemplateEmailDTO> {

    return this.http.get<TemplateEmailDTO>( API_CONFIG.apiURL+'/templatesemail/' + id);

  }

  findByTipoTemplateNaoEditavel(tipoTemplateEmail: string) : Observable<TemplateEmailDTO> {

    return this.http.get<TemplateEmailDTO>( API_CONFIG.apiURL+'/templatesemail/findByTipoTemplateNaoEditavel?tipoTemplateEmail=' + tipoTemplateEmail);

  }


  findByFilter(filtro: string) : Observable<TemplateEmailDTO[]> {

    return this.http.get<TemplateEmailDTO[]>( API_CONFIG.apiURL+'/templatesemail/findByFilter?filtro=' + filtro);

  }


  delete(id: number) : Observable<void> {

    return this.http.delete<void>( `${API_CONFIG.apiURL}${'/templatesemail/'}${id}`);

  }


  getNomeTipo(tipoTemplateNaoEditavel: string){

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.CADASTRO_CANDIDATO){
      return 'Confirmação de cadastro de candidato';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.EDICAO_CADASTRO_CANDIDATO){
      return 'Alteração de cadastro do candidato';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.INSCRICAO){
      return 'Confirmação de inscrição em curso';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.INSCRICAO_MEDICINA){
      return 'Confirmação de inscrição no curso Medicina';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.RESULTADO_CLASSIFICACAO){
      return 'Resultado do vestibular';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.RESULTADO_CLASSIFICACAO_MEDICINA){
      return 'Resultado do vestibular - Medicina';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.ALTERAR_SENHA){
      return 'Envio de link para alteração de senha';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.LEMBRETE_AGENDAR_PROVA){
      return 'Lembrete para agendar prova';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.CONVOCACAO_PROVA_CURSOS_SEMESTRAIS){
      return 'Convocação para prova';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.CONVOCACAO_PROVA_MEDICINA){
      return 'Convocação para prova - Medicina';
    }
  
    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.ENVIO_CARTAO_CONFIRMACAO){
      return 'Envio do cartão de confirmação';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.ENVIO_CODIGO_VALIDACAO_EMAIL){
      return 'Envio de código de validação de e-mail';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.PENDECIAS_DOCUMENTACAO_MATRICULA){
      return 'Pendência de documentação para Matrícula';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.PENDECIAS_DOCUMENTACAO_INSCRICAO){
      return 'Pendência de documentação de Inscrição';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.RESULTADO_GERAL_MEDICINA){
      return 'Resultado geral de Medicina';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.BENEFICIO_INSCRICAO_RAPIDA){
      return 'Benefício por inscrição imediata';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.BENEFICIO_INSCRICAO_RAPIDA){
      return 'Benefício por inscrição imediata';
    }

    if(tipoTemplateNaoEditavel===TIPO_TEMPLATE_EMAIL.ENVIO_BOLETO_PAGAMENTO_INSCRICAO){
      return 'Envio de boleto para pagamento de inscrição';
    }
   
    return '';
  }

}
